import { Button } from "@mui/material";

import LoadingCircle from "../loadingCircle/LoadingCircle";

interface AsyncButtonProps {
  sendRequest: () => void;
  className?: string;
  loading?: boolean;
  disabled?: boolean;
  variant?: "text" | "outlined" | "contained";
}

const AsyncButton = (props: React.PropsWithChildren<AsyncButtonProps>) => {
  const { sendRequest, className, loading, disabled, variant, children } =
    props;

  return (
    <Button
      className={className}
      variant={variant || "contained"}
      disabled={disabled}
      onClick={sendRequest}
    >
      {children}
      {loading && <LoadingCircle className="ml-10" size={16} />}
    </Button>
  );
};

export default AsyncButton;
